import logisticTripRoutesService from "../shared/services/logisticTripRoutesService";

const REQUEST_ADD_ROUTE_LOGISTIC_TRIP = "REQUEST_ADD_ROUTE_LOGISTIC_TRIP";
const RESPONSE_ADD_ROUTE_LOGISTIC_TRIP = "RESPONSE_ADD_ROUTE_LOGISTIC_TRIP";
const REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE = "REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE";

const requestAddRouteLogisticTripAction = () => {
  return {
    type: REQUEST_ADD_ROUTE_LOGISTIC_TRIP,
  };
};

const responseAddRouteLogisticTripAction = () => {
  return {
    type: RESPONSE_ADD_ROUTE_LOGISTIC_TRIP,
  };
};

const requestAddURouteLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const addLogisticTripRoute = (route, tripId) => {
  return (dispatch) => {
    dispatch(requestAddRouteLogisticTripAction());

    logisticTripRoutesService
      .addLogisticTripRoute({ routeId: route.id, tripId })
      .then((result) => {
        dispatch(responseAddRouteLogisticTripAction());
      })
      .catch((error) => {
        dispatch(requestAddURouteLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_ROUTE_LOGISTIC_TRIP = "REQUEST_DELETE_ROUTE_LOGISTIC_TRIP";
const RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP = "RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP";
const REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE = "REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE";

const requestDeleteRouteLogisticTripAction = () => {
  return {
    type: REQUEST_DELETE_ROUTE_LOGISTIC_TRIP,
  };
};

const responseDeleteRouteLogisticTripAction = () => {
  return {
    type: RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP,
  };
};

const requestDeleteRouteLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const deleteLogisticTripRoute = (route, tripId) => {
  return (dispatch) => {
    dispatch(requestDeleteRouteLogisticTripAction());

    logisticTripRoutesService
      .deleteLogisticTripRoute({ routeId: route.id, tripId })
      .then((result) => {
        dispatch(responseDeleteRouteLogisticTripAction());
      })
      .catch((error) => {
        dispatch(requestDeleteRouteLogisticTripFailureAction(error.response));
      });
  };
};

const REQUEST_ALARM_ROUTE_LOGISTIC_TRIP = "REQUEST_ALARM_ROUTE_LOGISTIC_TRIP";
const RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP = "RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP";
const REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE = "REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE";

const requestAlarmRouteLogisticTripAction = () => {
  return {
    type: REQUEST_ALARM_ROUTE_LOGISTIC_TRIP,
  };
};

const responseAlarmRouteLogisticTripAction = () => {
  return {
    type: RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP,
  };
};

const requestAlarmRouteLogisticTripFailureAction = (errors) => {
  return {
    type: REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE,
    errors,
  };
};

const updateLogisticTripRouteAlarm = (options) => {
  return (dispatch) => {
    dispatch(requestAlarmRouteLogisticTripAction());

    logisticTripRoutesService
      .updateLogisticTripRouteAlarm(options)
      .then((result) => {
        dispatch(responseAlarmRouteLogisticTripAction());
      })
      .catch((error) => {
        dispatch(requestAlarmRouteLogisticTripFailureAction(error.response));
      });
  };
};

export {
  REQUEST_ADD_ROUTE_LOGISTIC_TRIP,
  RESPONSE_ADD_ROUTE_LOGISTIC_TRIP,
  REQUEST_ADD_ROUTE_LOGISTIC_TRIP_FAILURE,
  addLogisticTripRoute,
  REQUEST_DELETE_ROUTE_LOGISTIC_TRIP,
  RESPONSE_DELETE_ROUTE_LOGISTIC_TRIP,
  REQUEST_DELETE_ROUTE_LOGISTIC_TRIP_FAILURE,
  deleteLogisticTripRoute,
  REQUEST_ALARM_ROUTE_LOGISTIC_TRIP,
  REQUEST_ALARM_ROUTE_LOGISTIC_TRIP_FAILURE,
  RESPONSE_ALARM_ROUTE_LOGISTIC_TRIP,
  updateLogisticTripRouteAlarm,
};
